<template>
  <div id="team" class="team-wrap bg-albastor ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Our Doctors</span>
            <h2>
              We provide <span>Exceptional Medical</span> Care For Our Patients
            </h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="team-slider-one style1"
      >
        <Slide v-for="team in teams" :key="team.id">
          <div class="team-card style4">
            <div class="team-info-wrap">
              <img :src="team.image" alt="Image" />

              <div class="team-info">
                <h3>{{ team.name }}</h3>
                <span>{{ team.designation }}</span>
              </div>
            </div>
            <div class="social-link">
              <span><i class="flaticon-share"></i></span>
              <div class="share-text">
                <p>Share With us</p>
              </div>
              <ul class="social-profile list-style style1">
                <li>
                  <a target="_blank" href="https://facebook.com">
                    <i class="ri-facebook-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com">
                    <i class="ri-twitter-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://instagram.com">
                    <i class="ri-instagram-line"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://linkedin.com">
                    <i class="ri-linkedin-line"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurDoctors",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    teams: [
      {
        id: 1,
        image: require("../../assets/images/team/member-9.jpg"),
        name: "Dr. Ken Moris",
        designation: "Urology Efficient",
      },
      {
        id: 2,
        image: require("../../assets/images/team/member-10.jpg"),
        name: "Dr. Michel Jhonson",
        designation: "Cardiology Efficient",
      },
      {
        id: 3,
        image: require("../../assets/images/team/member-11.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Neurosurgery Efficient",
      },
      {
        id: 4,
        image: require("../../assets/images/team/member-12.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Neurosurgery Efficient",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>